const LOCKED_VIEWPORT =
  'width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no, viewport-fit=cover, interactive-widget=resizes-content'

let installed = false
let lastTouchEnd = 0

function getViewportMeta() {
  let viewport = document.querySelector('meta[name="viewport"]') as HTMLMetaElement | null
  if (!viewport) {
    viewport = document.createElement('meta')
    viewport.name = 'viewport'
    document.head.appendChild(viewport)
  }
  return viewport
}

function lockViewportMeta() {
  const viewport = getViewportMeta()
  if (viewport.content !== LOCKED_VIEWPORT) {
    viewport.content = LOCKED_VIEWPORT
  }
}

function isEditableElement(target: EventTarget | null) {
  if (!(target instanceof HTMLElement)) {
    return false
  }
  return Boolean(target.closest('input, textarea, select, [contenteditable="true"]'))
}

function clearHorizontalOffset() {
  document.documentElement.scrollLeft = 0
  document.body.scrollLeft = 0
  document.getElementById('root')?.scrollTo({ left: 0 })
}

function resetViewportAfterKeyboard() {
  lockViewportMeta()
  clearHorizontalOffset()

  window.requestAnimationFrame(() => {
    lockViewportMeta()
    clearHorizontalOffset()
  })
}

export function installMobileViewportLock() {
  if (installed || typeof window === 'undefined') {
    return
  }

  installed = true
  lockViewportMeta()

  document.addEventListener(
    'touchstart',
    (event) => {
      if (event.touches.length > 1) {
        event.preventDefault()
      }
    },
    { passive: false },
  )

  document.addEventListener('gesturestart', (event) => {
    event.preventDefault()
  })

  document.addEventListener(
    'touchend',
    (event) => {
      const now = Date.now()
      if (now - lastTouchEnd <= 300) {
        event.preventDefault()
      }
      lastTouchEnd = now
    },
    { passive: false },
  )

  document.addEventListener(
    'focusin',
    (event) => {
      if (isEditableElement(event.target)) {
        lockViewportMeta()
        clearHorizontalOffset()
      }
    },
    true,
  )

  document.addEventListener(
    'focusout',
    () => {
      window.setTimeout(resetViewportAfterKeyboard, 80)
      window.setTimeout(resetViewportAfterKeyboard, 260)
      window.setTimeout(resetViewportAfterKeyboard, 520)
    },
    true,
  )

  window.visualViewport?.addEventListener('scroll', () => {
    if (!isEditableElement(document.activeElement)) {
      clearHorizontalOffset()
    }
  })
}
